import Controller from '@ember/controller'
import { tracked } from '@glimmer/tracking'

export default class ReStudentSummaryCourseProgressReadingController extends Controller {
  queryParams = ['currentMapNumber']
  @tracked currentMapNumber = 1

  changeMap = (currentMapNumber: number) => {
    this.currentMapNumber = currentMapNumber
  }
}
